export const content = {
  whenInsertSim: 'When should you insert your SIM?',
  learnMore: 'Learn more',
}
